module.exports = __webpack_public_path__ + "img/bg.aec015c5.png";